import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { renderCustomizedLabel, renderCustomLegend } from '../custom-legend-label/custom-legend-label';
import { ChartColorsArray } from '@families-link/shared';
import { CoreLoadingWall } from '../../../_core/components/_ui/core-loading-wall';
import { FadeSpinner } from '../../../_core/components/_ui/fade-spinner';

type EngagementsPieChartProps = {
	data: any;
	title?: string;
	useRandomColor?: boolean;
	colorsEnum?: any;
	loading?: boolean;
};

export const EngagementsStatusesPieChart = (props: EngagementsPieChartProps) => {
	const { data, title, useRandomColor = true, colorsEnum, loading } = props;
	const [t] = useTranslation();
	if (loading) {
		return (
			<Box sx={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
				<FadeSpinner size={51} height={15} width={6} borderRadius={3} />
			</Box>
		);
	}

	return data && data?.length ? (
		<Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
			<Typography sx={{ color: (theme) => theme.colors.grayLightBlue, fontSize: '16px', fontWeight: 500, pb: '12px' }}>
				Engagements Status
			</Typography>
			<Box sx={{ height: 'calc(100% - 36px)' }}>
				<ResponsiveContainer width="100%" height="100%">
					<PieChart>
						<Pie
							data={data}
							dataKey="total"
							nameKey="pieChartKey"
							cx="50%"
							cy="50%"
							outerRadius="95%"
							labelLine={false}
							label={renderCustomizedLabel}
						>
							{data?.map((entry: any, index: number) => (
								<Cell
									key={`cell-${index}`}
									fill={
										useRandomColor
											? ChartColorsArray[index % ChartColorsArray.length]
											: colorsEnum
											? colorsEnum[entry.pieChartKey]
											: entry?.pieChartColor
									}
								/>
							))}
						</Pie>
						<Tooltip />
						<Legend align="right" verticalAlign="middle" layout="vertical" content={renderCustomLegend} />
					</PieChart>
				</ResponsiveContainer>
			</Box>
		</Box>
	) : (
		<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
			<Typography sx={{ color: (theme) => theme.colors.grayLightBlue, fontSize: '16px', fontWeight: 500 }}>
				No data found for the chart
			</Typography>
		</Box>
	);
};
